import React from "react"

import { Form, Formik } from "formik"

import { gql, useMutation } from "hooks/urql"

import {
  FormFailures,
  SubmitButton,
  handleFailure,
} from "components/Forms/Formik/hookComponents"
import ModalWithProvidedBody from "components/ModalWithProvidedBody"

const RemoveCollege = ({ college, isOpen, onClose }) => {
  const formState = { collegeId: college?.id }
  const [, removeCollege] = useMutation(removeCollegeMutation)

  const handleSubmit = (values, actions) => {
    removeCollege(values)
      .then(
        response => {
          const { failures } = response.data.removeCollege
          if (failures) {
            handleFailure(actions, failures)
          } else {
            window.location.reload()
          }
        },
        () => handleFailure(actions)
      )
      .catch(() => handleFailure(actions))
  }

  return (
    <ModalWithProvidedBody
      hideTrigger
      modalTitle="Remove College"
      isOpen={isOpen}
      closeModal={onClose}
    >
      {({ closeModal }) => (
        <Formik initialValues={formState} onSubmit={handleSubmit}>
          <Form>
            <div className="modal-body">
              <p className="alert alert-danger">
                Are you sure? This will permaanently remove this college. It
                will not change any existing degree's college field.
              </p>
            </div>

            <div className="modal-footer flex-col">
              <FormFailures />
              <div className="w-100 flex justify-between">
                <button type="button" className="btn" onClick={closeModal}>
                  Cancel
                </button>
                <SubmitButton text="Remove" className="btn btn-danger" />
              </div>
            </div>
          </Form>
        </Formik>
      )}
    </ModalWithProvidedBody>
  )
}

const removeCollegeMutation = gql`
  mutation ($collegeId: ID!) {
    removeCollege(collegeId: $collegeId) {
      failures {
        message
      }
      college {
        id
      }
    }
  }
`

export default RemoveCollege
